import { useCallback, useMemo } from 'react'

import usePublicPlans from '../views/Subscription/hooks/usePublicPlans'
import { companyHasPlanModuleAccess, isCatalogAvailable } from '../utils/planModuleAccess'

export function usePlanModuleNav(userInfo) {
  const { plans, isLoading, fetchError } = usePublicPlans()
  const catalogAvailable = isCatalogAvailable(plans, fetchError)
  const canAccessPlanModule = useCallback(
    (moduleKey) =>
      companyHasPlanModuleAccess(userInfo, plans, moduleKey, {
        catalogAvailable,
        fetchError,
      }),
    [userInfo, plans, catalogAvailable, fetchError],
  )
  const catalogReady = useMemo(() => !isLoading || catalogAvailable, [isLoading, catalogAvailable])
  return { plans, catalogReady, catalogAvailable, canAccessPlanModule }
}

export default usePlanModuleNav
